module.exports = __webpack_public_path__ + "img/novo-pacote.b12b274f.svg";